import { render, staticRenderFns } from "./currentsAccounts.vue?vue&type=template&id=385bdc6a&scoped=true&"
import script from "./currentsAccounts.vue?vue&type=script&lang=js&"
export * from "./currentsAccounts.vue?vue&type=script&lang=js&"
import style0 from "./currentsAccounts.vue?vue&type=style&index=0&id=385bdc6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385bdc6a",
  null
  
)

export default component.exports